export enum EConfirmationDialogStatus {
    CANCEL = 'CANCEL',
    YES = 'YES',
    NO = 'NO',
}
